import { authRoles } from 'app/auth';
import { lazy } from 'react';

const CommercialProposalAppConfig = {
	settings: {
		layout: {}
	},
	auth: [...authRoles.salesAgent, ...authRoles.diller],
	routes: [
		{
			path: '/apps/sales-agents/commercial-proposals',
			exact: true,
			component: lazy(() => import('./List'))
		},
		{
			path: '/apps/sales-agents/commercial-proposals/new',
			exact: true,
			component: lazy(() => import('./Create'))
		}
	]
};

export default CommercialProposalAppConfig;
